import { render, staticRenderFns } from "./BarConsultationsISTByMois.vue?vue&type=template&id=1da54538&"
import script from "./BarConsultationsISTByMois.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByMois.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports